<template>
  <NavbarComponents />
  <router-view />
  <FooterComponents />
</template>

<script>
import NavbarComponents from './components/NavbarComponents.vue'
import FooterComponents from './components/FooterComponents .vue'

export default {
  name: 'App',
  components: {
   NavbarComponents,
   FooterComponents,
  }
}
</script>

<style lang="scss">
@import "@/style/color.scss";
@import "@/style/effets.scss";
@import "https://unpkg.com/open-props";
// @import "./style/_reboot.scss";
#app{
  background-color: transparent;
}

body{
  background: #ffff;
}
router-link {
  display: block;
}
*{
  margin: 0;
  padding: 0;
  font-size: 16px;
  text-decoration: none;
  list-style-type: none;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: $NNAC;
}
</style>
